import React from "react";
import { Collapse } from "antd";
import Textfield from "@atlaskit/textfield";

const { Panel } = Collapse;

const ContextLogAppender = ({ value, onChange }) => {
  return (
    <div style={{ maxWidth: 420, marginBottom: 12 }}>
      <Collapse defaultActiveKey={[]} ghost size="small">
        <Panel header="Context Log Appender" key="context-log-appender">
          <Textfield isCompact name="contextLogAppender" value={value} onChange={onChange} placeholder="Correlate context in logs" />
          <p style={{ marginTop: 6, marginBottom: 0, fontSize: 12 }}>
            You can use mustache variables from the scope (e.g. {"{{issue.key}}"}) to append dynamic values into the context field in the
            log.
          </p>
        </Panel>
      </Collapse>
    </div>
  );
};

export default ContextLogAppender;
